<template>
  <v-container fluid class="mt-4 pa-0">
    <v-row>
      <v-col cols="12" md="12" class="mt-2">
        <el-text-field
          required
          label="Identifikavimo kodas (IDK)"
          tooltip="Paieška. Kodas. Identifikavimo kodas (IDK)"
          v-model="mainData.obj_identifikavimo_kodas"
          autofocus
          idk
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PaieskaKodas',
  props: {
    mainData: Object,
  },
  $_veeValidate: {
    validator: '$validator',
  },
}
</script>
<style lang="scss" scoped></style>
